export enum TicketMailType {
    WithConfirmation = 0,
    DaysBeforeEvent = 1,
    Manual = 2
}
